
import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import {get} from 'lodash';
import ApplicationForm from './r_ApplicationForm';

@connect(store => ({
  labels: get(store.labels, 'Common', {}),
}))
export default class Application extends Component {

  static propTypes = {
    labels: PropTypes.object.isRequired,
  }

  render() {
    return (
      <div>
        <div className='instructions mobile-hide'
             data-id='Display Text' dangerouslySetInnerHTML={{__html: get(this.props.labels, 'applyInstructions')}}>
        </div>
        <div className='instructions mobile-only'
             data-id='Display Text' dangerouslySetInnerHTML={{__html: get(this.props.labels, 'applyInstructionsMb')}}>
        </div>
        <ApplicationForm/>
    </div>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/react/f_PreliminaryApplication/f_Application/index.js